import type { InternalAxiosRequestConfig } from 'axios';
import { getAuthToken } from './firebase';
import { getImpersonationUserId } from '../stores/impersonationStore';
import { getApiBaseUrl } from '../utils/apiConfig';

/** The signed-in user's token, and the user an admin is viewing as. Every per-user API call sends both. */
export async function authHeaders(): Promise<Record<string, string>> {
  const headers: Record<string, string> = {};
  const token = await getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const viewingAs = getImpersonationUserId();
  if (viewingAs) headers['X-Impersonate-User'] = viewingAs;
  return headers;
}

/** Request interceptor for every axios instance that reads or writes the user's own data. */
export async function authorizeRequest(config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
  config.baseURL = getApiBaseUrl();
  config.headers.set(await authHeaders());
  return config;
}
